<tiime-dialog [isLoading]="isLoading()" loaderPosition="end" (cancel)="closeCreateCompanyDialog()">
  @if (!submitLoading()) {
    <span mat-dialog-title>Ajouter un dossier</span>
  }
  <div class="dialog-container">
    @if (!submitLoading()) {
      <tiime-stepper orientation="vertical" linear #tiimeStepper>
        @for (step of state.availableSteps; let i = $index; track i) {
          @if (step | includes: 'User') {
            <tiime-step
              #userStep
              [stepControl]="state.form.userStep"
              label="Contact"
              [description]="
                tiimeStepper.stepIsNavigable(i, userStep)
                  | map
                    : mapToUserStepDescription
                    : state.form.userStep.user.lastName.value
                    : state.form.userStep.user.firstName.value
                  | titlecase
              "
            >
              <tiime-table-anchor></tiime-table-anchor>
              @if (userExistingCompanies().length) {
                <div class="flex column gap-20">
                  <tiime-alert primary>
                    Il existe un ou plusieurs dossiers associés au dirigeant sélectionné.
                  </tiime-alert>
                  <app-duplicated-users-container
                    [duplicatedUsers]="userExistingCompanies()"
                    [displayAction]="dialogData().prospect"
                    (actionClicked)="selectUserExistingCompany($event)"
                  ></app-duplicated-users-container>
                </div>
              } @else {
                <tiime-card>
                  <app-create-user-form
                    [formGroup]="state.form.userStep.user"
                    [capacities]="capacities"
                  ></app-create-user-form>
                </tiime-card>
              }
              <div tiimeStepperActions>
                @if (userExistingCompanies().length) {
                  <button tiime-button large color="accent" strocked (click)="resetUserExistingCompanies()">
                    <mat-icon>chevron_left</mat-icon>
                    Précédent
                  </button>
                  <button tiime-button large color="accent" raised (click)="goToUserNextStep()">
                    Ajouter un nouveau dossier
                  </button>
                } @else {
                  <div></div>
                  <button tiime-button large color="accent" raised (click)="validateUserStep()">
                    Suivant
                    <mat-icon>chevron_right</mat-icon>
                  </button>
                }
              </div>
            </tiime-step>
          }
          @if (step | includes: 'Company') {
            <tiime-step
              #companyStep
              [stepControl]="state.form.companyStep"
              label="Entreprise"
              [description]="
                tiimeStepper.stepIsNavigable(i, companyStep)
                  | map: mapToCompanyStepDescription : state.form.companyStep.company.name.value
                  | capitalize
              "
            >
              <tiime-table-anchor></tiime-table-anchor>
              @if (businessUserPartnerExistingCompanies().length) {
                <div class="flex column gap-20">
                  <tiime-alert primary>Il existe un dossier qui possède le même numéro de SIRET.</tiime-alert>
                  <tiime-list>
                    @for (company of businessUserPartnerExistingCompanies(); track company.id) {
                      <tiime-list-item>
                        <mat-icon svgIcon="icon-dossier" color="primary" tiimeListItemIcon></mat-icon>
                        <div tiimeListItemTitle>
                          {{ company.name }}
                        </div>
                        <div tiimeListItemActions></div>
                        <span class="company-infos">
                          {{
                            company
                              | companyInfosLabel
                                : []
                                : 'SIRET : ' +
                                    (company.siret | mask: siretMask) +
                                    ' • ' +
                                    'Groupe : ' +
                                    company.businessUnit?.name
                          }}
                        </span>
                      </tiime-list-item>
                    }
                  </tiime-list>
                </div>
              } @else {
                <tiime-card>
                  <app-create-company-form
                    [formGroup]="state.form.companyStep.company"
                    [businessUnits]="dialogData().businessUnits"
                    [displayedForms]="state.companyStepDisplayedForms"
                    synchronizeBuWithLegalStructure
                  ></app-create-company-form>
                </tiime-card>
              }
              <div tiimeStepperActions>
                @if (businessUserPartnerExistingCompanies().length) {
                  <button
                    tiime-button
                    large
                    color="accent"
                    strocked
                    (click)="resetBusinessUserPartnerExistingCompanies()"
                  >
                    <mat-icon>chevron_left</mat-icon>
                    Précédent
                  </button>
                } @else {
                  <button tiime-button large color="accent" strocked tiimeStepperPrevious>
                    <mat-icon>chevron_left</mat-icon>
                    Précédent
                  </button>
                  <button tiime-button large color="accent" raised (click)="validateCompanyStep()">
                    @if (i === state.availableSteps?.length - 1) {
                      Ajouter le dossier
                    } @else {
                      Suivant
                      <mat-icon>chevron_right</mat-icon>
                    }
                  </button>
                }
              </div>
            </tiime-step>
          }
          @if (step | includes: 'Invitation') {
            <tiime-step
              #invitationStep
              [stepControl]="state.form.invitationStep"
              label="Invitation"
              [description]="
                tiimeStepper.stepIsNavigable(i, invitationStep)
                  | map
                    : mapToInvitationStepDescription
                    : state.form.invitationStep.invitation.features.controls.invoiceApp.value
              "
            >
              <tiime-table-anchor></tiime-table-anchor>
              <tiime-card>
                <app-invitation-form
                  [formGroup]="state.form.invitationStep.invitation"
                  [userPhoneNumber]="state.form.userStep.user.phone.value"
                ></app-invitation-form>
                <tiime-slide-toggle-container [selected]="state.form.companyStep.company.tiimeBusinessOptin.value">
                  <mat-slide-toggle
                    color="primary"
                    [formControl]="state.form.companyStep.company.tiimeBusinessOptin"
                    slideToggleContainerPrefix
                    (click)="$event.stopPropagation()"
                  ></mat-slide-toggle>
                  <div slideToggleContainerContent>
                    J’autorise Tiime à contacter le client pour le compte professionnel
                  </div>
                </tiime-slide-toggle-container>
                @if (state.form.invitationStep.invitation.touched && state.form.invitationStep.invitation.invalid) {
                  <tiime-alert warn>Veuillez sélectionner au moins un type d'envoi (email et/ou SMS)</tiime-alert>
                }
              </tiime-card>
              <div tiimeStepperActions>
                <button tiime-button large color="accent" strocked tiimeStepperPrevious>
                  <mat-icon>chevron_left</mat-icon>
                  Précédent
                </button>
                <button
                  tiime-button
                  large
                  color="accent"
                  raised
                  (click)="state.form.invitationStep.markAllAsTouched()"
                  tiimeStepperNext
                >
                  Suivant
                  <mat-icon>chevron_right</mat-icon>
                </button>
              </div>
            </tiime-step>
          }
          @if (step | includes: 'Parameters') {
            <tiime-step
              #parametersStep
              [stepControl]="state.form.parametersStep"
              label="Paramétrage"
              [description]="
                tiimeStepper.stepIsNavigable(i, parametersStep)
                  | map
                    : mapToParametersStepDescription
                    : state.form.parametersStep.labelMode.value
                    : state.form.parametersStep.fecFile.value
                    : state.form.parametersStep.labelPlan.value
                    : (labelsPlans$ | async)
              "
            >
              <tiime-table-anchor></tiime-table-anchor>
              <tiime-card class="parameters-step-card">
                <app-company-initialization-form
                  [formGroup]="state.form.parametersStep"
                  [labelsPlans]="labelsPlans$ | async"
                  [labelCategoryPlans]="labelCategoryPlans$ | async"
                  [withFEC]="!isCapitalDeposit()"
                ></app-company-initialization-form>
              </tiime-card>
              <div tiimeStepperActions>
                <button tiime-button large color="accent" strocked tiimeStepperPrevious>
                  <mat-icon>chevron_left</mat-icon>
                  Précédent
                </button>
                <button tiime-button large color="accent" raised (click)="submitForm()">Ajouter le dossier</button>
              </div>
            </tiime-step>
          }
        }
      </tiime-stepper>
    } @else {
      <div class="submit-loader">
        <span>Création du dossier en cours...</span>
        <mat-progress-spinner diameter="80" color="primary" mode="indeterminate"></mat-progress-spinner>
      </div>
    }
  </div>
</tiime-dialog>
